import React, { useContext } from "react";
import "../Style/PPAStyles.css";

import PPAContext from "../../../../contexts/PPA/PPAContext";
import { modelTypes } from "../../../../utils/PPA/PPAMasterList";

const SelectModel = () => {
  const { formData, SetFormData, SetActiveTabId, errors } =
    useContext(PPAContext);

  const handleChange = ({ target }) => {
    if (target.name === "modelType") {
      const newState = { ...formData, [target.name]: target.value };
      SetFormData(newState);
      if (target.value) {
        SetActiveTabId("2");
      }
    }
  };

  const startValuation = () => {
    SetActiveTabId("2");
  };

  return (
    <div className="add-evaluation_wrapper">
      <div className="add-evaluation-form-container col-md-12">
        <form className="add-evaluation-form col-md-12" onSubmit={() => {}}>
          <div className="col-md-3">
            <label className="avf-label" htmlFor="model-type">
              Select Model Type *
            </label>
            <div className="input-wrapper">
              <select
                className="admin__contract__input"
                id="model-type"
                name="modelType"
                value={formData?.modelType}
                onChange={handleChange}
                required
              >
                <option value="">Please Select A Model</option>
                {modelTypes.map((model) => (
                  <option
                    id={model.value}
                    value={model.value}
                    key={model.value}
                    disabled={model.disabled}
                  >
                    {model.label}
                  </option>
                ))}
              </select>
              <span className="cppa-custom-tooltip">Select Model Type</span>
            </div>
            {errors.modelType ? (
              <p className="error">Please select a model type</p>
            ) : null}
          </div>
        </form>
        <div className="ppa-actions">
          <button
            disabled={!formData?.modelType}
            className="forward__option btn-primary"
            onClick={startValuation}
          >
            Next
          </button>
        </div>
      </div>
      <div className="info-container">
        <span>NOTE: Fields marked (*) are mandatory.</span>
      </div>
    </div>
  );
};
export default SelectModel;
